import { render, staticRenderFns } from "./VCheckbox.vue?vue&type=template&id=5e6db912&lang=pug&functional=true&"
import script from "./VCheckbox.vue?vue&type=script&lang=js&"
export * from "./VCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports